import { memo } from "react";
import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";

/** A preset card's tiny picture of its plan: temperature, humidity and water level, no axes. */
function PlanSparkline({ points }) {
  if (!points.length) return <div className="h-12" />;
  const hasLevel = points.some((p) => typeof p.level === "number");
  return (
    <div className="h-12" aria-hidden="true">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={points} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <YAxis yAxisId="temp" hide domain={[20, 62]} />
          <YAxis yAxisId="rh" hide domain={[25, 100]} />
          <YAxis yAxisId="level" hide domain={[10, 45]} />
          <Line yAxisId="temp" dataKey="temp" stroke="#ea580c" dot={false} strokeWidth={1.5} isAnimationActive={false} />
          <Line yAxisId="rh" dataKey="rh" stroke="#0e7490" dot={false} strokeWidth={1.5} isAnimationActive={false} />
          {hasLevel && <Line yAxisId="level" dataKey="level" stroke="#2563eb" dot={false} type="stepAfter" strokeWidth={1.5} connectNulls isAnimationActive={false} />}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default memo(PlanSparkline);
